/* 
	Duplicate the children inside a logo marquee, for scrolling purposes. 
	A marquee group contains either: a row group with child figures OR
	a gallery figure with child figures
*/
(function () {
	let marquees = document.querySelectorAll('.is-style-marquee')
	marquees.forEach((marquee) => {
		let children = marquee.children[0].children
		let childrenCopy = Array.from(children, (el) => {
			let clone = el.cloneNode(true)
			clone.setAttribute('aria-hidden', 'true');
			clone.querySelector('img')?.setAttribute('alt', '');
			return clone
		})
		children[children.length - 1].after(...childrenCopy)
	})
})()